import React from "react";
import batiment from "../assets/BATIMENT.gif";
import qualibat from "../assets/LOGO-RGE.png";

const About = () => {
  return (
    <main className="container">
      <img
        src={batiment}
        alt="Batiment rs logo GIF"
        href="#"
        style={{
          width: "100%",
          maxWidth: "500px",
          margin: "0 auto",
          display: "block",
        }}
      />
      <h1
        className="text-center"
        style={{
          // Couleur du texte
          fontSize: "2.5em", // Taille de la police
          fontWeight: "bold", // Épaisseur du texte
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", // Ombre du texte
          margin: "20px 0", // Marges en haut et en bas
          padding: "10px", // Padding autour du texte
          borderRadius: "10px", // Coins arrondis
          backgroundColor: "#0A6847",
          color: "aliceblue",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Ombre du conteneur
        }}
      >
        Plus de 20 ans d'éxperience
      </h1>
      <div className="col-auto text-center">
        <img
          src={qualibat}
          alt="rge qualibat logo PNG"
          style={{
            maxWidth: "90px",
          }}
        />
      </div>
      <h2 style={{ color: "#ebe4e1" }}>Batiment RS || batiment rs</h2>
      <div className="col">
        <h4
          className="text-center"
          style={{
            fontWeight: "bold", // Épaisseur du texte
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", // Ombre du texte
            margin: "20px 0", // Marges en haut et en bas
            padding: "10px", // Padding autour du texte
            borderRadius: "10px", // Coins arrondis
            backgroundColor: "#0A6847",
            color: "aliceblue",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Ombre du conteneur
          }}
        >
          Entreprise qualifié QUALIBAT depuis 2015
          <br />
          <br />
          N° de certificat : E-E127164
        </h4>
      </div>
      <h2
        id="about"
        style={{ marginTop: "100px", textDecoration: "underline" }}
      >
        À Propos de nous:
      </h2>
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-12 col-md-10 col-lg-8">
            <h3 className="mt-4">
              <strong>Batiment RS</strong>
            </h3>
            <p style={{ fontSize: "20px" }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;est une entreprise
              située à Saint-Jean-Rohrbach, spécialisée dans:
              <strong> Ravalement de façades</strong>,<strong> Crépis</strong>,
              <strong> Peinture</strong> et les
              <strong> services d'isolation</strong>. Notre équipe d'experts se
              consacre à améliorer l'efficacité énergétique et l'esthétique de
              votre habitat grâce à des solutions innovantes et durables. En
              choisissant Batiment RS, vous bénéficiez d'un service de qualité
              supérieure, alliant professionnalisme et savoir-faire, pour tous
              vos projets de rénovation. Faites confiance à notre expérience
              pour transformer votre maison en un espace confortable et économe
              en énergie.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;
